module.exports = __webpack_public_path__ + "img/empreendimento-logo-25.58326c58.png";